import { Box, Paper, Typography } from "@mui/material";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { analyticsTheme, cardSx } from "../theme";

interface AnalyticsUnavailableStateProps {
  message: string;
  variant?: "info" | "error";
}

export const AnalyticsUnavailableState = ({
  message,
  variant = "info",
}: AnalyticsUnavailableStateProps) => {
  const isError = variant === "error";
  const accentColor = isError ? "#e5484d" : analyticsTheme.brand;
  const accentSoft = isError ? "#fdecec" : analyticsTheme.brandSoft;
  const Icon = isError ? ReportProblemOutlinedIcon : InsightsOutlinedIcon;

  return (
    <Paper
      elevation={0}
      sx={{
        ...cardSx,
        py: { xs: 6, sm: 9 },
        px: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        gap: 2,
      }}
      data-testid="analytics-unavailable"
    >
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: "50%",
          backgroundColor: accentSoft,
          color: accentColor,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "& svg": { fontSize: 36 },
        }}
      >
        <Icon />
      </Box>
      <Typography
        sx={{
          maxWidth: 420,
          fontSize: 15,
          fontWeight: 500,
          lineHeight: 1.6,
          color: analyticsTheme.text.secondary,
        }}
      >
        {message}
      </Typography>
    </Paper>
  );
};
